import React from "react";

const CAT_COLORS = [
  "#FCE7F6", "#F8D6E7", "#F5BAE5", "#EAB2B8", "#F6AC9B", "#E99494", "#FF8F9D", "#E55D5D",
  "#F1F9DD", "#E5F7C6", "#D3F0A4", "#C0D2A2", "#BCEC75", "#B8E7A1", "#B2E7B8", "#41C373",
  "#E4FDF0", "#D3F8FD", "#D6E6FF", "#C5D9E7", "#BEE6FF", "#B6CFFF", "#5CF5FD", "#749ADB",
  "#F9FDD1", "#EDFA91", "#FADA8E", "#E3DABC", "#EEC8A6", "#EABF99", "#ECC975", "#C58247",
  "#F4ECFF", "#E0D3FF", "#D1BEFF", "#DDACDD", "#B3A1DE", "#B799FD", "#7C5BCA", "#6A3DD4"
];

// Helper to get a darker border color
function getDarkerColor(hex, percent = 15) {
  let r = parseInt(hex.slice(1,3), 16);
  let g = parseInt(hex.slice(3,5), 16);
  let b = parseInt(hex.slice(5,7), 16);
  r = Math.max(0, r - Math.floor(255 * percent / 100));
  g = Math.max(0, g - Math.floor(255 * percent / 100));
  b = Math.max(0, b - Math.floor(255 * percent / 100));
  return `rgb(${r},${g},${b})`;
}

export default function CatColorPicker({ label="Pick Color",defaultColor, onSelect }) {
  const [selected, setSelected] = React.useState(defaultColor);

  React.useEffect(() => {
    setSelected(defaultColor);
  }, [defaultColor]);

  return (
    <><label className="text-xs font-regular mb-0.5 text-gray-700 flex items-center gap-1 mb-1">{label}</label>
    <div className="w-full flex flex-wrap gap-3 justify-start">
      {CAT_COLORS.map((color) => {
        const isActive = selected === color;
        return (
          <button
            key={color}
            type="button"
            onClick={() => {
              setSelected(color);
              if (onSelect) onSelect(color);
            }}
            className={`w-8 h-8 rounded-full transition-all duration-150
              ${isActive ? "scale-110 shadow-lg" : ""}
              focus:outline-none`}
            style={{
              backgroundColor: color,
              border: isActive
                ? `3px solid ${getDarkerColor(color, 25)}`
                : "2px solid #fff",
            }}
            aria-label={`Pick color ${color}`}
          />
        );
      })}
    </div>
    </>
  );
}
